<template>
	
	<div class="ticket" @click.stop="onClick">
		
		<div class="ticket__title-bar">
			<RecordButton style="float: left; margin-right: 8px;" :ticket="ticket" :ticket_id="ticket.id" :project_id="ticket.project.id" :client_id="ticket.project.client_id"/>
			<h3 class="ticket__title">{{ ticket.name }}</h3>
			<el-button v-if="showOpenTicketButton" class="ticket__menu" icon="el-icon-d-arrow-right" @click.stop="onClickOpenTicket"></el-button>
			<el-dropdown v-if="$auth.check(['edit_tickets', 'delete_tickets']) && showOverflowMenu" @command="onClickTicketMenu" style="float: right;">
				<el-button class="ticket__menu ticket__menu--more" icon="el-icon-more"></el-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item v-if="$auth.check('edit_tickets')" command="edit"><ion-icon name="create"></ion-icon>Edit Task</el-dropdown-item>
					<el-dropdown-item v-if="$auth.check('delete_tickets')" command="delete"><ion-icon name="trash"></ion-icon>Delete Task</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
		
		<div class="ticket__detail-container">
			
			<el-tag class="no-margin" size="mini" :type="statusType" :title="statusDescription"><ion-icon :name="statusIcon"></ion-icon>{{ ticket.status }}</el-tag>
			
			<el-tag v-if="ticket.due_date" :class="{ 'hidden': taskCompleted, 'ticket--overdue': taskOverdue }" size="mini" type="info" title="Due date"><ion-icon name="calendar"></ion-icon>{{ ticket.due_date | dateFormatted }}</el-tag>
			
			<p title="Category" class="ticket__detail"><ion-icon name="checkbox"></ion-icon>{{ ticket.type }}</p>
			
			<p v-if="showComments" title="Comments" class="ticket__detail"><ion-icon name="chatboxes"></ion-icon>{{ comments }}</p>
			
		</div>
		
		<h4 v-if="showProjectName" class="ticket__project-name"><img v-if="ticket.project.logo_url" v-bind:src="ticket.project.logo_url">{{ ticket.project.name }}</h4>
		
	</div>
	
</template>

<script>
	
	import RecordButton from "@/components/TimeBook/RecordButton";
	
	export default {
		
		components: { RecordButton },
		
		props: {
			ticket: { default() { return {}; } },
			showComments: { default: true, type: Boolean },
			showProjectName: { default: false, type: Boolean },
			showOpenTicketButton: { default: false, type: Boolean },
			showOverflowMenu: { default: true, type: Boolean },
		},
		
		computed: {
			
			comments() {
				if (this.ticket.comments.length) {
					if (this.ticket.comments.length > 1) {
						return `${this.ticket.comments.length} comments`;
					}
					return "1 comment";
				}
				return "No comments";
			},
			
			statusType() {
				switch (this.ticket.status) {
					case "Rejected":
						return "danger";
					case "Approved":
						return "warning";
					case "In Progress":
						return "warning";
					case "Completed":
						return "success";
					case "Finalised":
						return "success";
					default:
						return "";
				}
			},
			
			statusIcon() {
				switch (this.ticket.status) {
					case "Rejected":
						return "close";
					case "Approved":
						return "checkmark";
					case "In Progress":
						return "sync";
					case "Completed":
						return "done-all";
					case "Finalised":
						return "sunny";
					default:
						return "time";
				}
			},
			
			statusDescription() {
				switch (this.ticket.status) {
					case "Rejected":
						return "This task has been rejected";
					case "Approved":
						return "This task has been approved";
					case "In Progress":
						return "This task is in progress";
					case "Completed":
						return "This task has been completed";
					case "Finalised":
						return "This task has been finalised";
					default:
						return "This task is pending";
				}
			},
			
			taskOverdue() {
				return new Date() > new Date(this.ticket.due_date);
			},
			
			taskCompleted() {
				switch (this.ticket.status) {
					case "Completed":
					case "Finalised":
						return true;
					default:
						return false;
				}
			},
			
		},
		
		methods: {
			
			onClickTicketMenu(action) {
				this.$emit(`on-${action}`, { ticket: this.ticket })
			},
			
			onClickOpenTicket() {
				this.$emit("on-open", { ticket: this.ticket });
			},
			
			onClick() {
				this.$emit("on-click", { ticket: this.ticket });
			}
			
		}
		
	}
	
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/Projects/Project/TicketsListItem.vue